import { render, staticRenderFns } from "./legal-person-case-manage.vue?vue&type=template&id=ec85d11c&scoped=true"
import script from "./legal-person-case-manage.vue?vue&type=script&lang=ts"
export * from "./legal-person-case-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec85d11c",
  null
  
)

export default component.exports